import Post from "../post/Post";
import "./posts.css";

export default function Posts({ posts }) {
  // console.log("check post: ", posts);
  return (
    <div className="posts-grid">
      {posts.map((p, index) => (
        <Post key={index} post={p} />
      ))}
    </div>
  );
}
